/**
 * Swiper
 */

"use strict";

import Swiper from 'swiper'; 
import { Navigation, Pagination, Autoplay } from 'swiper/modules';


export class SwiperControls {
  /**
   * Constructor 
   */
  constructor() {
    window.addEventListener('load', () => {
      document.querySelectorAll('.swiper').forEach( ( item ) => {
        const loop         = (item.dataset.loop === 'true') ? true : false;
        const slides       = (item.dataset.slidesToShow) ?? 1;
        const mobileSlides = (item.dataset.MobileslidesToShow) ?? 1;

        new Swiper( item, {
          modules: [Navigation, Pagination, Autoplay],
          slidesPerView: mobileSlides,
          spaceBetween: 20,
          loop: loop,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: slides,
            }
          }
        });
      });
    });
  }
}
